export default {
  title: "Basic Information",
  caseType: "Case Type",
  creator: "Creator",
  createTime: "Create Time",
  updateTime: "Update Time",
  description: "Case Description",
};
